import { html } from '@shared/utils/rendering/html';
import { Icon, IconNames } from '@shared/components/icons';

import ActionsDropdown from '@shared/components/dropdowns/actions-dropdown';
import ActionsDropdownItem from '@shared/components/dropdowns/actions-dropdown/actions-dropdown-item';

export default function UsersTableActions(row) {
    return html`
        <${ActionsDropdown}>
            <${ActionsDropdownItem}
                disabled=${false}
                onClickEvent=${() => {}}
                href='/Admin/Users/${row.id}'
                params=${null}
                label=${{
                    text: 'Edit User',
                    icon: html`<${Icon} name=${IconNames.Edit} />`,
                }}
            />
        </${ActionsDropdown}>
    `;
}
